// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/survey-loans/:sessionId/complete\",\"regex\":\"^/survey-loans/([^/]+)/complete$\",\"paramNames\":[\"sessionId\"],\"hasOptionalPrefix\":false},{\"path\":\"/survey-loans/:sessionId/q/:step\",\"regex\":\"^/survey-loans/([^/]+)/q/([^/]+)$\",\"paramNames\":[\"sessionId\",\"step\"],\"hasOptionalPrefix\":false},{\"path\":\"/survey-loans/:sessionId/thank-you\",\"regex\":\"^/survey-loans/([^/]+)/thank-you$\",\"paramNames\":[\"sessionId\"],\"hasOptionalPrefix\":false},{\"path\":\"/studio/:tool*?\",\"regex\":\"^/studio(?:/(.*))?$\",\"paramNames\":[\"tool\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/survey-loans\"},{\"path\":\"/survey-loans/verify\"},{\"path\":\"/cookies\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"},{\"path\":\"/_v1/cookies\"},{\"path\":\"/_v1/privacy\"},{\"path\":\"/_v1/terms\"},{\"path\":\"/admin/login\"},{\"path\":\"/admin\"},{\"path\":\"/admin/dashboard\"},{\"path\":\"/admin/surveySessions\"},{\"path\":\"/admin/v1/survey-sessions/export\"},{\"path\":\"/debug/sentry-example-page\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.1";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://def9ff2d631fceab6ded47050c58615b@o4510356695744512.ingest.de.sentry.io/4510356697579600",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;